"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userGroupRoutes = void 0;
exports.userGroupRoutes = [
    {
        name: 'user-group.list',
        path: ['/', '/q/:q'],
        method: 'GET'
    },
    {
        name: 'user-group.create',
        path: '/',
        method: 'POST'
    },
    {
        name: 'user-group.get',
        path: '/:id',
        method: 'GET'
    },
    {
        name: 'user-group.update',
        path: '/:id',
        method: 'PUT'
    },
    {
        name: 'user-group.delete',
        path: '/:id',
        method: 'DELETE'
    }
];
